/**
 * PHARMAKON — Le BANDEAU du palier « info » (INFO).
 *
 * PLAN_mobile_pharma_owner_manager §3.5, ligne « Info ».
 *
 * CONTRAT : bandeau dans la fente principale de l'`AppShell`, SOUS
 * `LicenceBanner`. Non modal ; il défile avec le contenu ; il s'empile jusqu'à
 * `max_bannieres` (défaut 2) avec un repli « +N » ; l'utilisateur peut le
 * rejeter, et ce rejet écrit `seen_at`.
 *
 * Le composant est monté DANS `<main>` (et non dans la couche fixe de
 * `AlerteHost`) précisément pour que « défile avec le contenu » soit vrai —
 * un bandeau `position: fixed` mangerait la hauteur utile du poste de vente,
 * ce que le contrat de mise en page zoom/défilement du POS interdit.
 */
import * as React from "react";
import { Info, X } from "lucide-react";
import { LIBELLE_PALIER } from "./alerte-equipe.config.js";

/**
 * @param {object} p
 * @param {object[]} p.alertes  déjà tronquées à `max_bannieres` par le magasin
 * @param {number} p.enTrop     combien de bandeaux ne sont pas affichés
 * @param {(id: string) => void} p.onFermer écrit `seen_at`
 */
export default function AlerteBannieres({ alertes = [], enTrop = 0, onFermer }) {
  if (alertes.length === 0) return null;

  return (
    <div
      className="pk-alerte-bannieres"
      data-testid="alerte-bannieres"
      aria-live="polite"
      aria-label="Alertes équipe"
    >
      {alertes.map((a) => (
        <div
          key={a.id}
          className="pk-alerte-banniere"
          data-testid="alerte-banniere"
          data-alerte-id={a.id}
        >
          <Info size={16} aria-hidden="true" className="pk-alerte-banniere-icone" />
          <div className="pk-alerte-banniere-corps">
            <span className="pk-alerte-banniere-palier">{LIBELLE_PALIER.INFO}</span>
            <span className="pk-alerte-banniere-titre">{a.titre}</span>
            <span className="pk-alerte-banniere-message">{a.message}</span>
          </div>
          <button
            type="button"
            className="pk-alerte-banniere-fermer"
            data-testid="alerte-banniere-fermer"
            aria-label={`Masquer l'information « ${a.titre} »`}
            onClick={() => onFermer?.(a.id)}
          >
            <X size={14} aria-hidden="true" />
          </button>
        </div>
      ))}

      {enTrop > 0 && (
        // Le repli « +N » : aucune information n'est jetée en silence, elle est
        // comptée et réapparaîtra dès qu'une place se libère.
        <div className="pk-alerte-banniere-roll" data-testid="alerte-bannieres-roll">
          +{enTrop} autre{enTrop > 1 ? "s" : ""} information
          {enTrop > 1 ? "s" : ""} en attente
        </div>
      )}
    </div>
  );
}
